import { Game } from "../../shared/data-access/store/game/types/game-types";
import {
  SocketEvent,
  SocketResponse,
} from "../../shared/data-access/store/game/types/requests";

type Response = SocketResponse<
  "update_round_answer",
  SocketEvent<"update_round_answer">
>;

type BonusGameResponse = {
  answer?: {
    answer_value: number;
    correct: boolean;
    correct_answer_details: number;
    answer_time: number;
  };
  opponent_answer?: {
    answer_index: number;
    correct: boolean;
    answer_time: number;
  };
};

export const assertCorrectAnswer = (
  results?: Response,
  game?: Game
): Response["data"]["round"] | false => {
  if (!results || !game || results.data.id !== game.id) {
    return false;
  }
  return results.data.round;
};

export const assertCorrectBonusAnswer = (
  results?: BonusGameResponse
): BonusGameResponse["answer"] | false => {
  if (!results || !results.answer) {
    return false;
  }
  return results.answer;
};
